// extracted by mini-css-extract-plugin
export var pricingCard = "index-module--pricing-card--af7f6";